import { createSlice } from "@reduxjs/toolkit";

export const savedAiPatientDetailsSlice = createSlice({
  name: "savedAiPatientDetails",
  initialState: {
    value: undefined,
  },
  reducers: {
    setSavedAiPatientDetails: (state, action) => {
      state.value = action.payload;
    },
    clearSavedAiPatientDetails: (state) => {
      state.value = undefined;
    },
  },
});

// actions
export const { setSavedAiPatientDetails, clearSavedAiPatientDetails } =
  savedAiPatientDetailsSlice.actions;

// reducer
export default savedAiPatientDetailsSlice.reducer;
